export const APP_VERSION = "v7.0.2";
export const LOYALTY_PROGRAM_PAGE = "loyalty-program";
export const CREATE_VOUCHER_PAGE = "create-voucher";
export const CREATE_COUPON_PAGE = "create-coupon";
export const CREATE_STAMP_PAGE = "create-single-reward-card";
export const ANALYTICS_PAGE = "analytics";
export const ANALYTICS_PRO_PAGE = "analytics-pro";
export const MANAGE_PROGRAM_PAGE = "programs";
export const MANAGE_VOUCHER_PAGE = "vouchers";
export const OVERVIEW_PAGE = "overview";
export const USER_MANAGEMENT_PAGE = "user-management";
export const LOOKER_PAGE = "looker";
export const CREATE_MILESTONE_STAMP = "create-milestone-stamp-card";
export const MANAGE_SINGLE_STAMP_CARD_PAGE = "manage-single-reward-card";
export const MANAGE_REWARD_PAGE = "rewards";
export const CREATE_REWARD_PAGE = "create-reward";
export const STAMP_REDEEM_PAGE = "stamp-redeem";
export const STAMP_CARD_PAGE = "stamp-card";
export const PUSH_NOTIFICATION_PAGE = "push-notifications";

/** After wizard completes: show welcome QR modal once on dashboard */
export const POST_WIZARD_WELCOME_VIDEO_SESSION_KEY =
  "meed_post_wizard_welcome_video_v1";

/**
 * Google Ads Express Launch conversion `send_to`.
 * Override with `REACT_APP_GOOGLE_ADS_CONVERSION_SEND_TO` in `.env` if needed.
 */
export const GOOGLE_ADS_EXPRESS_LAUNCH_CONVERSION_SEND_TO = (
  process.env.REACT_APP_GOOGLE_ADS_CONVERSION_SEND_TO ??
  "AW-18026179983/SYuyCLO5vbUcEI_bxpND"
).trim();

/** Primary marketing / UI orange used across portal (analytics, loaders, etc.) */
export const MEED_BRAND_ORANGE = "#e06932";

export const POST_WIZARD_WELCOME_MODAL_TITLE = "Your program is set up";
export const POST_WIZARD_WELCOME_MODAL_BODY =
  "Customers can scan this QR code, or tap the link you share to join your loyalty program.";
export const POST_WIZARD_WELCOME_MODAL_QR_LABEL = "QR CODE";
export const POST_WIZARD_WELCOME_MODAL_MOBILE_QR_HINT =
  "Tap and hold QR code, then save to photos.";
export const POST_WIZARD_WELCOME_MODAL_GET_QR_CTA = "Get my QR code";
export const POST_WIZARD_WELCOME_MODAL_DASHBOARD_CTA = "Go to dashboard";
export const POST_WIZARD_WELCOME_MODAL_QR_LOADING = "Generating QR code…";
export const POST_WIZARD_WELCOME_MODAL_QR_UNAVAILABLE =
  "QR code will appear here once your program is ready.";
export const POST_WIZARD_WELCOME_MODAL_QR_DOWNLOAD_SUCCESS =
  "Your join QR code has been downloaded.";
export const POST_WIZARD_WELCOME_MODAL_QR_DOWNLOAD_FAIL =
  "Could not download your QR code. Please try again.";
export const POST_WIZARD_WELCOME_MODAL_JOIN_LINK_LABEL = "Join link";
export const POST_WIZARD_WELCOME_MODAL_JOIN_LINK_LOADING = "Loading";
/** Shown in the join-link field when program uuid is not ready (layout preview). */
export const POST_WIZARD_WELCOME_MODAL_JOIN_LINK_PLACEHOLDER =
  "gomeed.io/uuid-abc1234";
export const POST_WIZARD_WELCOME_MODAL_COPY_CTA = "Copy";
export const POST_WIZARD_WELCOME_MODAL_COPY_SUCCESS = "Link copied";
export const POST_WIZARD_WELCOME_MODAL_COPY_FAIL =
  "Could not copy — select and copy manually.";

export const VoucherType = {
  DISCOUNT: 1,
  CASH: 2,
  GIVEAWAY: 3,
  EVENT_PASS: 4,
};

export const CampaignPageStep = {
  CARD_ONE: 1,
  CARD_TWO: 2,
  CARD_THREE: 3,
};

export const VOUCHER_TERMS_N_CONDITIONS =
  "1. You can earn a stamp in your stamp card (if any) from an eligible purchase transaction or activity. A completed stamp card unlocks a reward which you can redeem (congratulations!).\n2. Valid from [START_DATE] to [END_DATE].\n3. Coupon/reward redemptions only in [BUSINESS]'s designated store for the listed product(s) or service(s), while stocks last and first-come-first-served. Product/service price as displayed/quoted at the store prevails. For an event pass, event admission is subject to event rules and entry requirements.\n4. Cannot be used with other promotions/discounts and not exchangeable for cash/cash equivalent. Refer to any additional requirement(s) specified in the coupon/reward/stamp card.\n5. [BUSINESS] reserves the rights to modify these terms and conditions, or terminate the coupon/reward/stamp card, without prior notice.\n6. In case of any dispute, [BUSINESS]'s decision is final and conclusive.\n7. In case of conflict or inconsistency, the English version of these terms and conditions prevails.";
export const MILESTONE_TERMS_N_CONDITIONS =
  "1. You can earn a stamp in your stamp card (if any) from an eligible purchase transaction or activity.\n2. By collecting the prescribed number of stamps, you reach a milestone. The stamp card may have one or more milestone(s). You can continue to collect more stamps to meet any higher milestones to unlock more vouchers for more rewards (keep it up!).\n3. Redemption is subject to terms and conditions, such as validity period, redemption location, product/service availability, and other requirement(s) specified in the reward/stamp card.\n4. Not exchangeable for cash/cash equivalent. Refer to any additional specified reward requirement(s).\n5. The Program Operator reserves the right to modify these terms and conditions or terminate the stamp card/voucher without prior notice.\n6. In case of any dispute, the Program Operator's decision is final and conclusive.\n7. In case of conflict or inconsistency, the English version of these terms and conditions prevails.";
export const PATTERNS = [
  "Rhombus",
  "ZigZag",
  "ZigZag3D",
  "Pluses",
  "Circles",
  "Diagonal",
  "Paper",
  "Wavy",
  "Rectangles",
];

export const MILLISECONDS_IN_ONE_DAY = 86400000;

export const DASHBOARD_ID = {
  OVERVIEW: Number(process.env.REACT_APP_OVERVIEW_D_ID),
  MEMBERSHIP: Number(process.env.REACT_APP_MEMBERSHIP_D_ID),
  VOUCHER: Number(process.env.REACT_APP_VOUCHER_D_ID),
  STAMP_CARD: Number(process.env.REACT_APP_STAMP_CARD_D_ID),
  MILESTONE_CARD: Number(process.env.REACT_APP_MILESTONE_CARD_D_ID),
  QRC_LOCATION: Number(process.env.REACT_APP_QRC_LOCATION_D_ID),
};

export const DASHBOARD_URL = {
  OVERVIEW: `Organisation+UUID=&hide_filter=Organisation+UUID&Loyalty+Program=&Location=&Date+Range=7+day&Organisation+Name=&hide_filter=Organisation+Name`,
  MEMBERSHIP: `Loyalty+Program=&Location=&Date+Range=7+day&Organisation+UUID=&hide_filter=Organisation+UUID&Organisation+Name=&hide_filter=Organisation+Name`,
  VOUCHER: `Organisation+UUID=&hide_filter=Organisation+UUID&Voucher+Campaign+Name=&Loyalty+Program=&Location=&Organisation+Name=&hide_filter=Organisation+Name&Date+Range=7+day`,
  STAMP_CARD: `Organisation+UUID=&hide_filter=Organisation+UUID&Loyalty+Program=&Location=&Organisation+Name=&hide_filter=Organisation+Name&Date+Range=7+day&Voucher+Campaign+Name=`,
  MILESTONE_CARD: `Organisation+UUID=&hide_filter=Organisation+UUID&Loyalty+Program=&Location=&Organisation+Name=&hide_filter=Organisation+Name`,
  QRC_LOCATION: `Organisation+UUID=&hide_filter=Organisation+UUID&Loyalty+Program=&Date+Range=7+day&Organisation+Name=&hide_filter=Organisation+Name&Location=`,
};

export const createDashboardURL = (
  basicURL: string,
  accountUuid: string,
  accountName: string,
  loyaltyProgram: string,
  locationNames: string[],
) => {
  return basicURL
    ?.replace("Loyalty+Program=", `Loyalty+Program=${loyaltyProgram}`)
    .replace("Organisation+UUID=", `Organisation+UUID=${accountUuid}`)
    .replace("Organisation+Name=", `Organisation+Name=${accountName}`)
    .replace(
      "Location=",
      `Location=${locationNames.map((x) => encodeURIComponent(x)).join(",")}`,
    );
};
